import dayjs from 'dayjs';

export default function getFormattedDateWithTime(
  date: string | number,
  format = 'DD.MM.YYYY HH:mm',
  keepLocalTime: boolean | undefined = undefined,
) {
  return dayjs(date).utc(keepLocalTime).format(format);
}
